import { createSelector } from '@reduxjs/toolkit';
import { selectOfferSellerTypes } from 'shared/selectors/jsonQuery';
import { selectOfferSellerOptions } from './selectOfferSellerOptions';
import { EOfferSeller } from '../../../../packages/api-models/common/json_query';

export const selectOfferSellerFilter = createSelector(
  [selectOfferSellerTypes, selectOfferSellerOptions],
  (value, options) => ({
    label: 'Продавец',
    value: value?.length ? (value as EOfferSeller[]) : [null],
    options,
  }),
);
